module.exports = __webpack_public_path__ + "static/04-645ace17c92cf7a054b6226c6277ec67.jpg";